export default __webpack_public_path__ + "static/escalated-85e3209eadf3eefb9466b87a17a7812e.svg";